﻿export default class RecommendedButton {
  constructor() {
    this.id = 'getRecommendedBrochureButton';
  }

  getHtml() {
    return `<button id="${this.id}" data-qa="get-recommendations-button" class="btn btn--yellow btn--48-lg" data-get-reco-brochure>Get More Info</button>`;
  }

  getNode() {
    return document.getElementById(this.id);
  }
}
